var _style, _rect, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeLogoLioWhiteHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "https://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 50",
    style: {
      enableBackground: "new 0 0 250 50"
    },
    xmlSpace: "preserve",
    width: "215px",
    height: "45px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#3DCD58;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFE;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -6.3,
    y: -6.5,
    className: "st0",
    width: 259.2,
    height: 63
  })), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LOGOS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st1",
    d: "M25.8,30.3H19v-12c0-0.4,0-1.1-0.8-1.1c-0.7,0-0.7,0.6-0.7,1.1v12.1c0,1,0.1,1.1,1.2,1.1h7.1 c0.5,0,1.1,0,1.1-0.6C26.9,30.3,26.3,30.3,25.8,30.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    className: "st1",
    d: "M28.9,21c-0.7,0-0.7,0.6-0.7,1v8.7c0,0.4,0,1,0.7,1c0.6,0,0.6-0.6,0.6-1V22 C29.6,21.6,29.6,21,28.9,21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "st1",
    d: "M28.9,17.5c-0.5,0-0.8,0.3-0.8,0.8c0,0.4,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8 C29.8,17.9,29.4,17.5,28.9,17.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "st1",
    d: "M34.2,18.9C34.2,19,34.2,19,34.2,18.9C34.2,19,34.2,19,34.2,18.9z M35.4,21.2H34v-0.9 c0-1.3,0.1-2.1,1.7-2.1c0.1,0,0.2,0,0.4,0c0.2,0,0.4,0,0.5,0c0.3,0,0.5-0.3,0.5-0.5c0,0,0-0.3-0.3-0.4c-0.2-0.1-0.9-0.2-1.6-0.2 c-0.5,0-0.9,0.1-1.3,0.3s-0.8,0.5-1,0.9c-0.1,0.2-0.3,0.7-0.3,1.9v1.1h-1.1c-0.2,0-0.8,0-0.8,0.4c0,0.5,0.6,0.5,0.8,0.5h1.1v8.5 c0,0.4,0,1,0.7,1c0.6,0,0.6-0.6,0.6-1v-8.5h1.4c0.6,0,0.8-0.2,0.8-0.5C36.3,21.2,35.7,21.2,35.4,21.2L35.4,21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    className: "st1",
    d: "M37.7,25.5c0.2-1.3,1.1-3.5,3.6-3.5c3.1,0,3.4,2.6,3.4,3.5H37.7z M46.1,25.6c0,0,0-1.2-0.6-2.4 c-0.3-0.7-0.8-1.2-1.4-1.6c-0.1,0-0.1-0.1-0.2-0.1l-0.1-0.1c-0.1-0.1-0.3-0.1-0.5-0.2h-0.1c-0.2-0.1-0.4-0.1-0.5-0.1h-0.1 c-0.2,0-0.4-0.1-0.7-0.1c0,0,0,0-0.1,0c-0.1,0-0.3,0-0.4,0c-1.6,0-2.9,0.5-3.7,1.5c-0.9,0.9-1.3,2.3-1.3,3.9s0.4,2.9,1.2,3.8 c0.4,0.5,1,0.9,1.6,1.1c0.7,0.3,1.4,0.4,2.2,0.4c1.9,0,3.1-0.8,3.7-1.4c0.7-0.7,0.9-1.5,0.9-1.7c0-0.3-0.3-0.6-0.6-0.6 c-0.3,0-0.5,0.2-0.6,0.4c-0.4,0.9-1,1.5-1.7,1.9c-0.5,0.2-1,0.3-1.5,0.3c-1.2,0-2.1-0.4-2.7-1.2c-0.6-0.7-0.9-1.8-0.9-3h7.2 C45.5,26.5,46.1,26.5,46.1,25.6L46.1,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "st1",
    d: "M52.8,17.1c-0.7,0-0.7,0.7-0.7,1.1v12.3c0,0.5,0,1.1,0.8,1.1c0.7,0,0.7-0.6,0.7-1.1V18.2 C53.6,17.7,53.6,17.1,52.8,17.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    className: "st1",
    d: "M76.9,24.6c0.5,0,0.7-0.4,0.7-0.7v-8.5h-1.5v8.5C76.1,24.2,76.4,24.6,76.9,24.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    className: "st1",
    d: "M62.9,26.4c-0.1-0.1-0.2-0.1-0.3-0.1h-0.1c-0.7-0.3-1.6-0.5-2.4-0.7c-0.8-0.2-1.6-0.3-2.1-0.6 c-0.6-0.3-0.9-0.7-0.9-1.3c0-1.1,1.3-1.6,2.7-1.6s2.4,0.5,2.7,1.4c0.2,0.5,0.3,0.6,0.6,0.6c0.6,0,0.6-0.5,0.6-0.5 c0-0.1-0.1-0.7-0.6-1.3c-0.3-0.3-0.7-0.6-1.2-0.8c-0.6-0.2-1.3-0.4-2.2-0.4c-1.5,0-2.6,0.4-3.2,1.2c-0.6,0.7-0.6,1.5-0.6,1.7 c0,0.7,0.4,1.4,1,1.9c0.7,0.4,1.3,0.6,2.7,0.9c0.4,0.1,0.8,0.2,1.3,0.3H61c0.7,0.2,2.1,0.5,2.1,1.8c0,1-0.9,1.9-3,1.9 c-1.5,0-2.5-0.6-3-1.7l0,0c-0.1-0.3-0.3-0.6-0.7-0.6c-0.2,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.3-0.2,0.4c0,0.6,0.5,1.4,1.2,1.9 c0.3,0.3,0.7,0.5,1.1,0.6c0.6,0.2,1.2,0.3,2,0.3c1.7,0,2.9-0.4,3.7-1.2c0.7-0.7,0.7-1.5,0.7-1.9C64.2,27.6,63.8,26.9,62.9,26.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    className: "st1",
    d: "M93.9,22.1C93.4,21.6,92.5,21,91,21c-2.1,0-2.9,1-3.5,1.7v-0.8c0-0.3,0-0.6-0.2-0.8h-0.1l0,0 C87.1,21,87,21,86.8,21c-0.7,0-0.7,0.6-0.7,1v8.7c0,0.5,0,1,0.7,1c0.2,0,0.3,0,0.4-0.1l0,0h0.1c0.2-0.2,0.2-0.5,0.2-0.8v-3.7 c0-1.7,0.1-2.5,0.4-3.1c0.3-0.5,0.7-1,1.3-1.3c0.5-0.3,1.2-0.5,1.8-0.5c0.9,0,1.7,0.4,2.1,1c0.4,0.5,0.4,1.3,0.4,2.1v5.6 c0,0.3,0,0.6,0.2,0.8c0,0,0,0,0.1,0l0,0c0.1,0.1,0.2,0.1,0.4,0.1c0.7,0,0.7-0.6,0.7-1v-5.9C94.8,24.2,94.8,23,93.9,22.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    className: "st1",
    d: "M79,16.9v1.5c2.4,0.8,4.2,3.1,4.2,5.9c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2 c0-2.7,1.7-4.9,4-5.8V17c-3.1,0.9-5.4,3.8-5.4,7.3c0,4.2,3.4,7.6,7.6,7.6s7.6-3.4,7.6-7.6C84.5,20.8,82.2,17.8,79,16.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    className: "st1",
    d: "M134.3,18.5c-2.5-1.1-4-1.6-5.5-1.6c-1.6,0-2.6,0.6-2.6,1.4c0,2.6,8.9,1.9,8.9,8 c0,3.4-2.8,5.3-6.7,5.3c-3.1,0-4.6-0.8-6.3-1.7v-3.8c2.5,1.7,4,2.2,6,2.2c1.7,0,2.6-0.6,2.6-1.6c0-2.9-8.9-1.8-8.9-8.1 c0-3,2.6-5,6.7-5c2,0,3.7,0.4,5.9,1.4L134.3,18.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    className: "st1",
    d: "M146.8,30.9c-1.5,0.5-2.7,0.8-4,0.8c-4.2,0-6.8-2.4-6.8-6.1c0-3.6,2.8-6.2,6.7-6.2 c1.2,0,2.7,0.3,4,0.8V23c-1-0.5-2.1-0.8-3-0.8c-2.2,0-3.7,1.3-3.7,3.4s1.4,3.5,3.5,3.5c0.9,0,1.7-0.2,3.3-0.8V30.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    className: "st1",
    d: "M179.1,24.2c0.2-1.6,1.1-2.6,2.6-2.6c1.4,0,2.4,1,2.6,2.6H179.1z M181.5,19.4 c-3.6,0-6.2,2.6-6.2,6.2s2.7,6.1,6.9,6.1c0.9,0,3.1,0,5.3-1.6v-2.3c-1.7,1.2-2.9,1.7-4.4,1.7c-2.3,0-3.8-1.2-3.9-3.3h8.5 C187.7,21.9,184.9,19.4,181.5,19.4L181.5,19.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    className: "st1",
    points: "189,31.5 192.7,31.5 192.7,19.6 189,19.6  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    className: "st1",
    d: "M203,28.2c-0.8,0.7-1.4,1-2.2,1c-1.7,0-2.9-1.4-2.9-3.6c0-2.4,1.1-3.7,3-3.7 c0.7,0,1.5,0.3,2.1,0.7L203,28.2L203,28.2z M203,14v6.2c-1-0.5-2-0.7-3.1-0.7c-3.4,0-5.7,2.5-5.7,6.1c0,3.5,2.3,6.1,5.5,6.1 c1.3,0,2.2-0.3,3.3-1.2v1h3.7V14H203L203,14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    className: "st1",
    d: "M212.2,24.2c0.2-1.6,1.1-2.6,2.6-2.6c1.4,0,2.4,1,2.6,2.6H212.2z M214.5,19.4 c-3.6,0-6.2,2.6-6.2,6.2s2.7,6.1,6.9,6.1c0.9,0,3.2,0,5.3-1.6v-2.3c-1.7,1.2-2.9,1.7-4.4,1.7c-2.3,0-3.8-1.2-3.9-3.3h8.5 C220.8,21.9,218,19.4,214.5,19.4L214.5,19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    className: "st1",
    d: "M226.2,23L226.2,23c1.2-2.5,2.4-3.6,3.8-3.6c0.7,0,1.4,0.3,2.5,1.1l-1,3.3 c-1-0.6-1.6-0.9-2.2-0.9c-1.4,0-2.2,1.3-3.1,3.5v5.1h-3.7V19.6h3.7V23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-18",
    className: "st1",
    d: "M192.9,14.7c0.3,0.9-0.3,2.2-1.4,2.9c-1.1,0.7-2.3,0.5-2.7-0.5c-0.4-0.9,0.3-2.2,1.4-2.9 C191.3,13.5,192.5,13.7,192.9,14.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    className: "st1",
    d: "M160.1,23.9c0-3.2-2.2-4.5-4.3-4.5c-1.5,0-2.7,0.6-3.7,2H152V14h-3.7v17.4h3.7v-7.5 c0.9-1.3,1.6-1.8,2.5-1.8c1.2,0,1.9,0.8,1.9,2.6v4.2c1.2-0.6,2.5-1,3.7-1.2L160.1,23.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-20",
    className: "st1",
    d: "M169.4,19.4c-1.5,0-2.7,0.6-3.9,1.9v-1.7h-3.7v8c1.3,0.1,2.9,0.7,3.7,1.7v-5.5 c1-1.5,1.7-2,2.6-2c1.1,0,1.9,0.7,1.9,2.4v7.2h3.7v-7.5C173.7,20.5,171.3,19.4,169.4,19.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-21",
    className: "st1",
    points: "175.8,34.8 171.5,34.8 171.5,37.9 175.6,37.9 175.6,39.2 171.5,39.2 171.5,42.4  175.9,42.4 175.9,43.7 170,43.7 170,33.5 175.8,33.5 175.8,34.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    className: "st1",
    points: "179.3,43.7 180.6,43.7 180.6,33.5 179.3,33.5  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-23",
    className: "st1",
    d: "M187.2,38c0.9,0,1.5,0.6,1.6,1.7h-3.4C185.6,38.6,186.2,38,187.2,38 M185.4,40.5h4.7 c0-2.5-1.1-3.7-2.9-3.7c-1.8,0-3.1,1.4-3.1,3.4c0,1.9,1.2,3.6,3.2,3.6c1.1,0,1.9-0.3,2.7-0.8v-1.3c-0.8,0.5-1.5,0.8-2.3,0.8 C186.3,42.6,185.6,41.9,185.4,40.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-24",
    className: "st1",
    d: "M198.7,38.7c-0.8-0.5-1.3-0.7-1.8-0.7c-1.2,0-2,0.9-2,2.3c0,1.4,0.9,2.2,2.3,2.2 c0.6,0,1.1-0.1,1.8-0.4v1.3c-0.4,0.2-1.3,0.4-2,0.4c-2,0-3.4-1.4-3.4-3.3c0-2.2,1.3-3.6,3.3-3.6c0.8,0,1.3,0.2,1.9,0.5v1.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-25",
    className: "st1",
    d: "M204.7,37h2.1v1.2h-2.1v3.4c0,0.8,0.6,1,1,1c0.5,0,1-0.2,1.5-0.5v1.2c-0.5,0.3-1.2,0.4-1.6,0.4 c-1.4,0-2.2-0.9-2.2-2.1v-3.5h-1.2V38l2.5-2.4V37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-26",
    className: "st1",
    d: "M211.9,37v1.5l0,0c0.7-1.2,1.3-1.7,1.9-1.7c0.5,0,1,0.3,1.6,0.8l-0.7,1.2 c-0.4-0.4-0.9-0.7-1.2-0.7c-0.9,0-1.6,0.9-1.6,2.1v3.5h-1.3V37L211.9,37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-27",
    className: "st1",
    d: "M229,38.7c-0.8-0.5-1.3-0.7-1.9-0.7c-1.2,0-2,0.9-2,2.3c0,1.4,0.9,2.2,2.3,2.2 c0.6,0,1.1-0.1,1.8-0.4v1.3c-0.5,0.2-1.3,0.4-2,0.4c-2,0-3.4-1.4-3.4-3.3c0-2.2,1.3-3.6,3.3-3.6c0.8,0,1.3,0.2,1.9,0.5L229,38.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-28",
    className: "st1",
    points: "219,43.7 220.3,43.7 220.3,37 219,37  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-29",
    className: "st1",
    d: "M220.3,34.6c0.1,0.3-0.1,0.8-0.5,1s-0.8,0.2-0.9-0.2c-0.1-0.3,0.1-0.8,0.5-1 C219.8,34.2,220.2,34.2,220.3,34.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-30",
    className: "st1",
    d: "M161.2,35.1c-0.2,0-0.3,0-0.4,0.1c0,0-0.1,0.1-0.1,0.2l-1.2,4.5c-0.3,1.6-2.2,3.2-4.7,3.2h-3.5 l0.6-2.3h2.3c0.2,0,0.4-0.1,0.6-0.3c0.1-0.1,0.1-0.2,0.1-0.3l0.9-3.9c0.3-1.6,1.9-3.3,4.5-3.3h3.6l-0.5,2.1H161.2z M162,37.9 l0.4-1.5h3.7c0.5-2.1,0.1-4.1-1.2-5.3c-2.6-2.6-8-1.7-12,2.2c-0.6,0.6-1.2,1.2-1.6,1.9h2.2l-0.5,1.5h-2.6 c-0.3,0.5-0.5,0.9-0.7,1.4h3.1l-0.5,1.5h-3.1c-0.5,2.2-0.2,4.3,1.1,5.6c2.6,2.6,8,1.7,12-2.2c0.7-0.7,1.3-1.4,1.8-2.1h-2.8 l0.4-1.5h3.3c0.2-0.5,0.5-0.9,0.6-1.4H162V37.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    className: "st1",
    points: "107.9,47 108.6,47 108.6,2.5 107.9,2.5  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeLogoLioWhiteHeader);
export default __webpack_public_path__ + "static/media/SE_logo-LIO-white_header.507e78a8f2afadfda3ff86f1fc6a9bcc.svg";
export { ForwardRef as ReactComponent };